<template>
  <div>
    <BaseFrame
      cancelText=""
      clearText=""
      :infosArr="infos"
    >
      <div class="container" slot="content">
        <div style="margin-bottom: 20px;">
          <lk-card>
            <ApprovalFlow :workNo="workNo"></ApprovalFlow>
          </lk-card>
        </div>
        <div>
          <lk-card title='申请内容'>
            <receiveLimitContent
              :formObject="applyObject"
              :fieldData="drugInfo"
              :config="applyContents"
            ></receiveLimitContent>
          </lk-card>
        </div>
      </div>
    </BaseFrame>
  </div>
</template>

<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import ApprovalFlow from '../../components/ApprovalFlow.vue';
import receiveLimitContent from '../../components/sale/receiveLimitContent.vue';
import sale from '../../services/sale';
import utils from '../../libs/utils';

export default {
  name: 'receiveableLimitCheck',
  components: {
    BaseFrame,
    ApprovalFlow,
    receiveLimitContent,
  },
  data() {
    return {
      workNo: '',
      infos: [],
      drugInfo: {},
      applyObject: {},
      auditStatusList: [
        {
          id: 1,
          name: '审批通过'
        },
        {
          id: 2,
          name: '审批驳回'
        },
        {
          id: 3,
          name: '审批中'
        },
        {
          id: 4,
          name: '过期'
        },
      ],
      applyContents: [
        [
          {
            type: 'span',
            title: '申请门店',
            key: 'storeName'
          },
          {
            type: 'span',
            title: '申请月份',
            key: 'takeMonth'
          },
        ],
        [
          {
            type: 'inputSearch',
            title: '申请商品',
            key: 'storeName',
            isShowInputSearch: false,
            value: '',
            showFields: [
              {
                title: '商品编码：',
                key: 'serialCode'
              },
              {
                title: '通用名：',
                key: 'approvedDrugNames'
              },
              {
                title: '商品名：',
                key: 'goodsName'
              },
              {
                title: '规格：',
                key: 'specifications'
              },
              {
                title: '包装单位：',
                key: 'drugMiniPackageUnit'
              },
              {
                title: '生产厂家：',
                key: 'producer'
              },
              {
                title: '采购价：',
                key: 'purchasePrice',
                isCheck: this.$route.params.id,
              },
              {
                title: '零售价：',
                key: 'retailPrice'
              },
              {
                title: '税率：',
                key: 'outputTaxRate'
              },
            ],
          },
        ],
        [
          {
            type: 'span',
            title: '未核销应收总数',
            key: 'verificationNum'
          },
          {
            type: 'span',
            title: '本月已申请限额',
            key: 'appliedAmount',
          },
        ],
        [
          {
            type: 'span',
            title: '本月已使用限额',
            key: 'usedMonth',
          },
          {
            type: 'span',
            title: '月均销售数量(近3月)',
            key: 'saleAveNum',
          },
        ],
        [
          {
            type: 'span',
            title: '本次申请数量',
            key: 'approvalAmount',
          },
          {
            type: 'span',
            title: '计划应收金额',
            key: 'receivablePrice',
          },
        ],
        [
          {
            type: 'span',
            title: '计划回款时间',
            key: 'receivableTime',
          },
          {
            type: 'upload',
            title: '附件',
            isCanEdit: false,
            uploadInfo: [
              {
                appendixName: '',
                appendixUrl: '',
              },
            ]
          }
        ],
        [
          {
            title: '申请原因',
            type: 'span',
            key: 'reason'
          }
        ]
      ]
    }
  },
  methods: {
    getData() {
      sale.getApprovalInfo({ id: this.$route.params.id }).then(res => {
        if (res.data.status === 200) {
          res.data.data.takeMonth = utils.formatDateToMonth(res.data.data.takeMonth);
          this.workNo = res.data.data.workCode;
          this.drugInfo = res.data.data;
          this.applyObject = res.data.data;
          this.$set(this.applyContents[5][1], 'uploadInfo', res.data.data.bizExtraVos);
          this.$set(this.applyContents[1][0], 'value', this.drugInfo.serialCode);
          let data = res.data.data;
          data.createTime = utils.formatTime(data.createTime);
          data.receivableTime = utils.formatDate(data.receivableTime);
          data.outputTaxRate = `${data.outputTaxRate}%`;
          this.infos = [{
              name: '申请单号:',
              value: data.code,
            },
            {
              name: '申请人:',
              value: data.createUserName,
            },
            {
              name: '申请时间:',
              value: data.createTime,
            },
            {
              name: '状态:',
              value: this.auditStatusList[data.auditStatus-1].name,
            },
          ];
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="less" scoped>
  
</style>
